export default __webpack_public_path__ + "static/media/no-internet-connection.8393cffe.svg";